import React, { Component } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  OutlinedInput,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import "../shop/shop.css";
import { Link } from "react-router-dom";
import Paper from "@mui/material/Paper";
import AddIcon from "@mui/icons-material/Add";
import {
  Delete,
  AssignmentTurnedIn,
  Close,
  ExpandMore,
  Restore,
  MoneyOff,
  DocumentScanner,
} from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  pdf,
} from "@react-pdf/renderer";
import {
  faBox,
  faClipboardList,
  faDolly,
  faTruck,
} from "@fortawesome/free-solid-svg-icons";
import { makeStyles } from "@mui/styles";
import {
  AddonHelper,
  Option,
  Product,
  ProductOption,
  ProductPrice,
} from "../../../classes/types/product/product";
import { ProductHandler } from "../../../classes/methods/productMethods/productMethods";
import defaultImage from "../../../assets/defaultImage.jpg";
import { CartHandler } from "../../../classes/methods/cartMethods/cartMethods";
import { Alert } from "@mui/lab";
import { Skeleton, Pagination } from "@mui/material";

import AddToCartBtn, {
  ECartBtnStatus,
} from "../../customComponents/addToCartBtntn/addToCartBtn";
import {
  AddonCartHelper,
  CartItem,
  CartItemAddon,
  CartItemOption,
  ConfigurableItem,
} from "../../../classes/types/cart/cart";
import { euroPrint } from "../../../classes/types/currencysettings";
import Carousel from "react-multi-carousel";
import CarouselCard from "../../customComponents/carouselCard/carouselCard";
import { AuthHandler } from "../../../classes/methods/authMethods/authMethods";
import "./product-view.css";
import { AddProductToLaterListRequest, LaterListAddonRequest, LaterListHandler } from "../../../classes/methods/laterListMethods/laterListMethods";
import dayjs from "dayjs";
import deepCopy from "../../../classes/utilities/deepcopy";
import LinkMui from "@mui/material/Link";
import { Breadcrumbs } from "@mui/material";
import { CategoryHandler } from "../../../classes/methods/categoryMethods/categoryMethods";
import ConfigurationDocument from "../../customComponents/configurationDocument/ConfigurationDocument";
import { PDFDownloadLink } from "@react-pdf/renderer";
import saveAs from "file-saver";


interface props {
  productIdToDisplay: string;
  categoryCode?: string;
}
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 6,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 6,
  },
  tablet: {
    breakpoint: { max: 1024, min: 600 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 600, min: 400 },
    items: 1,
  },
  smallMobile: {
    breakpoint: { max: 400, min: 0 },
    items: 1,
  },
};

interface state {
  addingToCart: boolean;
  selectedProduct: Product;
  showAddToCartDialog: boolean;
  configurationDocument: any | undefined;
  correlatedProduct: Array<Product>;
  productPrices: Array<ProductPrice>;
  loading: boolean;
  loadingProduct: boolean;
  loadingConfiguration: boolean;
  productOptions: Array<ProductOption>;
  productAddons: Array<AddonHelper>;
  productsByAddon: Array<Product>;
  showAddedToCart: boolean;
  selectedCategory: string;
  selectedQuantity: number;
  selectedAddons: Array<AddonCartHelper>;
  quantityArray: Array<number>;
  showAddToCartAlert: boolean;
  loggedIn: boolean;
  loadingCorrelated: boolean;
  showAddedToLaterList: boolean;
  openLaterListError: boolean;
  selectedImage: any;
  productsError: Array<any>;
  errorDialog: boolean;
}

const useStyles = makeStyles({
  content: {
    margin: "0px !important",
    cursor: "default",
  },
  root: {
    cursor: "default",
  },
});

class ProductView extends Component<props, state> {
  constructor(props: props) {
    super(props);

    this.state = {
      addingToCart: false,
      configurationDocument: undefined,
      selectedProduct: new Product(),
      showAddToCartDialog: false,
      loading: true,
      loadingProduct: true,
      loadingConfiguration: true,
      correlatedProduct: new Array<Product>(),
      productPrices: new Array<ProductPrice>(),
      productOptions: new Array<ProductOption>(),
      showAddedToCart: false,
      selectedCategory: "",
      productAddons: new Array<AddonHelper>(),
      productsByAddon: new Array<Product>(),
      selectedQuantity: 1,
      selectedAddons: new Array<AddonCartHelper>(),
      quantityArray: new Array<number>(),
      showAddToCartAlert: false,
      loggedIn: false,
      loadingCorrelated: true,
      showAddedToLaterList: false,
      openLaterListError: false,
      selectedImage: "",
      productsError: new Array<any>(),
      errorDialog: false,
    };
  }

  componentDidMount() {
    this.refreshData();
  }

  componentDidUpdate(prevProps: Readonly<props>) {
    if (prevProps.productIdToDisplay !== this.props.productIdToDisplay) {
      this.refreshData();
    }
  }

  refreshData = () => {
    console.log("Refresh data is called");
    this.setState({
      loading: true,
      loadingProduct: true,
      loadingCorrelated: true,
      loadingConfiguration: true,
      addingToCart: false,
      configurationDocument: undefined,
      selectedProduct: new Product(),
      showAddToCartDialog: false,
      correlatedProduct: new Array<Product>(),
      productPrices: new Array<ProductPrice>(),
      productOptions: new Array<ProductOption>(),
      showAddedToCart: false,
      selectedCategory: "",
      productAddons: new Array<AddonHelper>(),
      selectedQuantity: 1,
      selectedAddons: new Array<AddonCartHelper>(),
      quantityArray: new Array<number>(),
      showAddToCartAlert: false,
      showAddedToLaterList: false,
      openLaterListError: false,
      selectedImage: "",
      productsError: new Array<any>(),
      errorDialog: false,
    });
    AuthHandler.isLogged().then((response) => {
      this.setState({
        loggedIn: !!response,
      });
      if (this.props.categoryCode !== undefined) {
        CategoryHandler.getCategoryByCode(this.props.categoryCode).then(
          (category) => {
            this.setState({
              selectedCategory: category.name,
            });
          }
        );
      }
      ProductHandler.getProduct(this.props.productIdToDisplay).then(
        (product) => {
          let newQuantityArray = new Array<number>();
          var max = product.stock1;
          if (max > 0) {
            let quantity = max > 100 ? 100 : max;
            for (let i = 0; i < quantity; i++) {
              newQuantityArray.push(i + 1);
            }
          } else if (product.configurable) {
            for (let i = 0; i < 5; i++) {
              newQuantityArray.push(i + 1);
            }
          } else {
            newQuantityArray.push(1);
          }
          this.setState({
            loadingProduct: false,
            selectedProduct: product,
            selectedImage:
              product.images.length > 0 ? product.images[0].link : defaultImage,
          });

          if (product.maker !== "") {
            ProductHandler.GetCorrelatedProducts(
              product.maker,
              product.id
            ).then((newCorrelatedProducts) => {
              this.setState({
                correlatedProduct: newCorrelatedProducts,
                loadingCorrelated: false,
              });
            });
          } else {
            this.setState({
              loadingCorrelated: false,
            });
          }
          ProductHandler.getAddons(product.id)
            .then(async (addonResponse) => {
              let newAddon = addonResponse.returningAddons;

              let standardOptions = new Array<AddonCartHelper>();
              let newAddonHelpers = new Array<AddonHelper>();

              newAddon.sort((a, b) => {
                if (a.sequence > b.sequence) return 1;
                if (a.sequence < b.sequence) return -1;
                return 0;
              });

              newAddon.forEach((addon) => {
                addon.options.sort((a, b) => {
                  if (a.sequence > b.sequence) return 1;
                  if (a.sequence < b.sequence) return -1;
                  return 0;
                });
              });

              newAddon.forEach((addon) => {
                let newAddonHelper = new AddonHelper();
                newAddonHelper.addon = addon;
                newAddonHelper.id = "_" + Math.random().toString(36).substr(2, 9);
                newAddonHelper.deletable = false;
                newAddonHelpers.push(newAddonHelper);

                if (addon.options.length < 1) {
                  let selectedAddon = new AddonCartHelper();
                  selectedAddon.id = newAddonHelper.id;
                  selectedAddon.selectedAddon.id = addon.id;
                  selectedAddon.selectedAddon.addonSku = addon.sku;
                  selectedAddon.selectedAddon.selectedOptionId = null;
                  selectedAddon.selectedAddon.addonName = addon.name;
                  selectedAddon.selectedAddon.selectedOptionName = "DEFAULT";
                  selectedAddon.selectedAddon.selectedOptionPrice = addon.addonPrice;

                  if (selectedAddon.selectedAddon.selectedOption === undefined) {
                    selectedAddon.selectedAddon.selectedOption = new CartItemOption();
                  }

                  selectedAddon.selectedAddon.selectedOption.price = 0;
                  selectedAddon.selectedAddon.selectedQuantity = 1;
                  standardOptions.push(selectedAddon);
                } else {
                  addon.options.every((option) => {
                    if (option !== null) {
                      let selectedAddon = new AddonCartHelper();
                      selectedAddon.id = newAddonHelper.id;
                      selectedAddon.selectedAddon.id = addon.id;
                      selectedAddon.selectedAddon.selectedOptionId = option.id;
                      selectedAddon.selectedAddon.addonName = option.name;
                      selectedAddon.selectedAddon.addonSku = addon.sku;

                      if (selectedAddon.selectedAddon.selectedOption !== undefined) {
                        selectedAddon.selectedAddon.selectedOption.price = option.price;
                      } else {
                        selectedAddon.selectedAddon.selectedOption = new CartItemOption();
                        selectedAddon.selectedAddon.selectedOption.price = option.price;
                      }

                      selectedAddon.selectedAddon.selectedQuantity = 1;
                      standardOptions.push(selectedAddon);
                      return false;
                    }
                    return true;
                  });
                }
              });

              const savedId = this.getSavedIdFromUrl();

              if (savedId) {
                const savedItem = await LaterListHandler.GetLaterListProduct(savedId);

                if (savedItem.configurationJson) {
                  const parsed: LaterListAddonRequest[] = JSON.parse(savedItem.configurationJson);

                  const grouped = parsed.reduce((acc, x) => {
                    const id = x.selectedAddon.id;
                    if (!acc[id]) acc[id] = [];
                    acc[id].push(x);
                    return acc;
                  }, {} as Record<string, LaterListAddonRequest[]>);

                  const restoredProductAddons: AddonHelper[] = [];

                  newAddonHelpers.forEach(baseAddon => {
                    const addonId = baseAddon.addon.id;
                    const savedGroup = grouped[addonId];

                    if (!savedGroup || savedGroup.length === 0) return;

                    savedGroup.forEach((saved, index) => {
                      const helper = new AddonHelper();

                      helper.addon = baseAddon.addon;
                      helper.id = saved.id;

                      // deletable come prima
                      helper.deletable = savedGroup.length > 1 && index > 0;

                      restoredProductAddons.push(helper);
                    });
                  });

                  const restoredSelectedAddons = parsed.map(x => {
                    const restored = new AddonCartHelper();

                    restored.id = x.id;

                    restored.selectedAddon = new CartItemAddon();
                    restored.selectedAddon.id = x.selectedAddon.id;
                    restored.selectedAddon.addonName = x.selectedAddon.addonName;
                    restored.selectedAddon.addonSku = x.selectedAddon.addonSku;
                    restored.selectedAddon.selectedOptionId =
                      x.selectedAddon.selectedOptionId;
                    restored.selectedAddon.selectedOptionName =
                      x.selectedAddon.selectedOptionName;
                    restored.selectedAddon.selectedOptionPrice =
                      x.selectedAddon.selectedOptionPrice;
                    restored.selectedAddon.selectedQuantity =
                      x.selectedAddon.selectedQuantity;

                    restored.selectedAddon.selectedOption =
                      x.selectedAddon.selectedOption ?? new CartItemOption();

                    return restored;
                  });

                  this.setState({
                    configurationDocument: ConfigurationDocument({
                      product: product,
                      productAddons: restoredProductAddons,
                      selectedAddons: restoredSelectedAddons,
                      quantity: savedItem.quantity ?? this.state.selectedQuantity,
                    }),
                    loading: false,
                    loadingConfiguration: false,
                    productAddons: restoredProductAddons,
                    selectedAddons: restoredSelectedAddons,
                    quantityArray: newQuantityArray,
                    productsByAddon: addonResponse.productByAddons,
                    selectedQuantity: savedItem.quantity ?? this.state.selectedQuantity,
                  });
                  return;
                }
              }

              this.setState({
                configurationDocument: ConfigurationDocument({
                  product: product,
                  productAddons: newAddonHelpers,
                  selectedAddons: standardOptions,
                  quantity: this.state.selectedQuantity,
                }),
                loading: false,
                loadingConfiguration: false,
                productAddons: newAddonHelpers,
                selectedAddons: standardOptions,
                quantityArray: newQuantityArray,
                productsByAddon: addonResponse.productByAddons,
              });
            })
            .catch((err) => {
              this.setState({
                loading: false,
                loadingConfiguration: false,
                quantityArray: newQuantityArray,
              });
            });
        }
      );
    });
  };

  CustomAccordion = () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const styles = useStyles();

    return (
      <div style={{ width: "100%" }}>
        {this.state.selectedProduct.description === "" ||
          this.state.selectedProduct.description === undefined ? (
          ""
        ) : (
          <Accordion classes={{ root: styles.root }} defaultExpanded={true}>
            <AccordionSummary
              expandIcon={<ExpandMore style={{ color: "white" }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              classes={{ content: styles.content }}
              style={{
                background: "#b3071b",
                color: "white",
                minHeight: "0px",
              }}
            >
              <Typography>Descrizione</Typography>
              <Divider />
            </AccordionSummary>
            <AccordionDetails
              style={{
                textAlign: "left",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {this.state.loadingProduct ? (
                <div style={{ width: "100%" }}>
                  <Skeleton width={"100%"} height={25} animation="wave" />
                  <Skeleton width={"100%"} height={25} animation="wave" />{" "}
                  <Skeleton width={"60%"} height={25} animation="wave" />
                </div>
              ) : (
                <Typography>
                  {this.state.selectedProduct.description !== ""
                    ? this.state.selectedProduct.description
                    : this.state.selectedProduct.shortDescription}
                </Typography>
              )}
            </AccordionDetails>
          </Accordion>
        )}
        {this.state.selectedProduct.options !== undefined &&
          this.state.selectedProduct.options.length > 1 ? (
          <Accordion classes={{ root: styles.root }} defaultExpanded={false}>
            <AccordionSummary
              classes={{ content: styles.content }}
              expandIcon={<ExpandMore style={{ color: "white" }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              style={{
                background: "#b3071b",
                color: "white",
                minHeight: "0px",
              }}
            >
              <Typography>Specifiche Tecniche</Typography>
              <Divider />
            </AccordionSummary>
            {
              <AccordionDetails style={{ textAlign: "left" }}>
                <ul>
                  {this.state.selectedProduct.options.map((option, index) => {
                    return (
                      <li key={index}>
                        {option}:<b style={{ marginLeft: "10px" }}>{option}</b>
                      </li>
                    );
                  })}
                </ul>
              </AccordionDetails>
            }
          </Accordion>
        ) : (
          ""
        )}
      </div>
    );
  };

  onConfigDownload = () => {
    pdf(this.state.configurationDocument).toBlob();
  }

  onQuantityChange = (e: any) => {
    this.setState({
      selectedQuantity: e.target.value,
    });
  };

  getSelectedOption = (addonHelper: AddonHelper) => {
    let optionSku = "";
    this.state.selectedAddons.every((selected) => {
      if (selected.id === addonHelper.id) {
        addonHelper.addon.options.every((option) => {
          if (option.id === selected.selectedAddon.selectedOptionId) {
            optionSku = option.sku;
            return false;
          }
          return true;
        });
        return optionSku === "";
      }
      return optionSku === "";
    });
    return optionSku;
  };

  getSelectedOptionPrice = (addonHelper: AddonHelper) => {
    let optionPrice = 0.0;
    addonHelper.addon.options.forEach((addonOption: Option) => {
      this.state.selectedAddons.every((option) => {
        if (
          option.id === addonHelper.id &&
          addonOption.id === option.selectedAddon.selectedOptionId
        ) {
          if (option.selectedAddon.selectedQuantity === 0) {
            optionPrice = addonOption.price;
          }
          else {
            optionPrice =
              addonOption.price * option.selectedAddon.selectedQuantity;
          }

          return false;
        }
        return true;
      });
    });
    return optionPrice;
  };

  navigateBack = () => {
    let newUrl;
    if (
      window.location.href.includes("prodotto") &&
      window.location.href.includes("page")
    ) {
      let url = window.location.href;
      newUrl = url
        .substr(0, url.indexOf("/prodotto"))
        .substr(url.indexOf("/shop"));
    } else {
      newUrl = "/";
    }
    return newUrl;
  };

  CustomBreadCrumbs = () => {
    let newUrl;
    if (
      window.location.href.includes("page") &&
      window.location.href.includes("category")
    ) {
      let url = window.location.href;
      newUrl = url
        .substr(0, url.indexOf("/prodotto"))
        .substr(url.indexOf("/shop"));
      return (
        <Breadcrumbs aria-label="breadcrumb">
          <LinkMui underline="hover" color="inherit">
            <Link to="/">HOME</Link>
          </LinkMui>
          {this.state.selectedCategory && (
            <LinkMui underline="hover" color="inherit">
              <Link to={newUrl}>{this.state.selectedCategory}</Link>
            </LinkMui>
          )}
          <Typography style={{ color: "black" }}>
            DETTAGLIO {this.state.selectedProduct.sku}
          </Typography>
        </Breadcrumbs>
      );
    }
    if (window.location.href.includes("cerca")) {
      let url = window.location.href;
      newUrl = url
        .substr(0, url.indexOf("/prodotto"))
        .substr(url.indexOf("/shop"));
      return (
        <Breadcrumbs aria-label="breadcrumb">
          <LinkMui underline="hover" color="inherit">
            <Link to="/">HOME</Link>
          </LinkMui>
          <LinkMui underline="hover" color="inherit">
            <Link to={newUrl}>RICERCA</Link>
          </LinkMui>
          <Typography style={{ color: "black" }}>
            DETTAGLIO {this.state.selectedProduct.sku}
          </Typography>
        </Breadcrumbs>
      );
    } else if (
      !window.location.href.includes("cerca") &&
      !window.location.href.includes("category") &&
      window.location.href.includes("page")
    ) {
      let url = window.location.href;
      newUrl = url
        .substr(0, url.indexOf("/prodotto"))
        .substr(url.indexOf("/shop"));
      return (
        <Breadcrumbs aria-label="breadcrumb">
          <LinkMui underline="hover" color="inherit">
            <Link to="/">HOME</Link>
          </LinkMui>
          <LinkMui underline="hover" color="inherit">
            <Link to={newUrl}>NEGOZIO</Link>
          </LinkMui>
          <Typography style={{ color: "black" }}>
            DETTAGLIO {this.state.selectedProduct.sku}
          </Typography>
        </Breadcrumbs>
      );
    } else if (!window.location.href.includes("page")) {
      return (
        <Breadcrumbs aria-label="breadcrumb">
          <LinkMui underline="hover" color="inherit">
            <Link to="/">HOME</Link>
          </LinkMui>
          <Typography style={{ color: "black" }}>
            DETTAGLIO {this.state.selectedProduct.sku}
          </Typography>
        </Breadcrumbs>
      );
    } else {
      return (
        <Breadcrumbs aria-label="breadcrumb">
          <LinkMui underline="hover" color="inherit">
            <Link to="/">HOME</Link>
          </LinkMui>
          {this.state.selectedCategory ? (
            <Typography style={{ color: "black" }}>
              {this.state.selectedCategory}
            </Typography>
          ) : (
            <Typography style={{ color: "black" }}>
              DETTAGLIO {this.state.selectedProduct.sku}
            </Typography>
          )}
        </Breadcrumbs>
      );
    }
  };

  handleRowSelectionChange = (targetIndex: any, addonHelper: AddonHelper) => {
    let selectedAddonsCopy = this.state.selectedAddons.slice();
    let found = false;
    selectedAddonsCopy.every((selected) => {
      if (selected.id === addonHelper.id) {
        if (targetIndex.target.value === "") {
          selected.selectedAddon = new CartItemAddon();
          found = true;
        } else {
          if (addonHelper.addon.options.length > 0) {
            addonHelper.addon.options.every((option) => {
              if (option.sku === targetIndex.target.value) {
                found = true;
                selected.selectedAddon.id = addonHelper.addon.id;
                selected.selectedAddon.selectedOptionId = option.id;
                selected.selectedAddon.addonName = option.name;
                selected.selectedAddon.selectedOptionPrice = option.price;
                selected.selectedAddon.selectedOption = new CartItemOption();
                selected.selectedAddon.selectedOption = option;
                selected.selectedAddon.addonSku = addonHelper.addon.sku;
                selected.selectedAddon.selectedQuantity = 1;

                return false;
              }
              return true;
            });
          } else {
            selected.selectedAddon.id = addonHelper.addon.id;
            selected.selectedAddon.addonName = addonHelper.addon.name;
            selected.selectedAddon.selectedOptionPrice =
              addonHelper.addon.addonPrice;
            selected.selectedAddon.selectedOption = new CartItemOption();
            selected.selectedAddon.addonSku = addonHelper.addon.sku;
            selected.selectedAddon.selectedQuantity = 1;
          }
        }

        return !found;
      }
      return !found;
    });
    this.setState({
      selectedAddons: selectedAddonsCopy,
      configurationDocument: ConfigurationDocument({
        product: this.state.selectedProduct,
        productAddons: this.state.productAddons,
        selectedAddons: selectedAddonsCopy,
        quantity: this.state.selectedQuantity,
      }),
    });
  };

  calculatePrice = (): number => {
    let calculatedPrice: number = 0;
    calculatedPrice =
      this.state.selectedProduct.discountedPrice === undefined
        ? this.state.selectedProduct.price === undefined
          ? 0
          : this.state.selectedProduct.price
        : this.state.selectedProduct.discountedPrice;
    if (this.state.selectedAddons !== null) {
      this.state.selectedAddons.forEach((addonCart: AddonCartHelper) => {
        calculatedPrice +=
          addonCart.selectedAddon.selectedQuantity *
          (addonCart.selectedAddon.selectedOptionPrice > 0
            ? addonCart.selectedAddon.selectedOptionPrice
            : addonCart.selectedAddon.selectedOption !== undefined
              ? addonCart.selectedAddon.selectedOption.price
              : 0);
      });
    }
    calculatedPrice +=
      this.state.selectedProduct.taxSIAE !== undefined
        ? this.state.selectedProduct.taxSIAE
        : 0;
    return calculatedPrice;
  };

  addToCartControl = () => {
    this.setState({
      addingToCart: true,
    });
    let newCartItem = new CartItem();
    newCartItem.productId = this.state.selectedProduct.id;
    newCartItem.product = this.state.selectedProduct;
    newCartItem.quantity = this.state.selectedQuantity;
    let newSelectedAddons = new Array<CartItemAddon>();
    let alert = false;
    this.state.selectedAddons.forEach((addon) => {
      if (addon.selectedAddon.selectedQuantity !== 0) {
        newSelectedAddons.push(addon.selectedAddon);
        this.state.productAddons.every((productAddon) => {
          let stopLoop = false;
          productAddon.addon.options.every((option) => {
            if (option.id === addon.selectedAddon.selectedOptionId) {
              if (
                option.obligatory < 0 &&
                option.stock1 <
                addon.selectedAddon.selectedQuantity *
                this.state.selectedQuantity
              ) {
                alert = true;
                return false;
              }
              stopLoop = true;
              return false;
            }
            return true;
          });
          return !stopLoop;
        });
      }
    });
    newCartItem.addons = newSelectedAddons;
    console.log(alert);
    if (alert) {
      this.setState({
        addingToCart: false,
        showAddToCartAlert: true,
      });
    } else {
      this.addCartItemToCart(newCartItem);
    }
  };

  addCartItemToCart = (newCartItem: CartItem) => {
    if (this.state.selectedAddons.length < 1) {
      CartHandler.addItemToCart(newCartItem)
        .then((response) => {
          this.setState({
            addingToCart: false,
            showAddedToCart: true,
            loading: false,
          });
        })
        .catch((err: any) => {
          if (Array.isArray(err.response.data)) {
            this.setState({
              errorDialog: true,
              productsError: err.response.data,
              addingToCart: false,
              loading: false,
            });
          }
        });
    } else {
      let newCartAddons = new Array<CartItemAddon>();
      this.state.selectedAddons.forEach((newAddon: AddonCartHelper) => {
        if (newAddon.selectedAddon.id !== "") {
          var newCartAddon = new CartItemAddon();
          newCartAddon = deepCopy(newAddon.selectedAddon);
          delete newCartAddon.selectedOption;
          newCartAddons.push(newCartAddon);
        }
      });
      // @ts-ignore
      delete newCartItem.addons;
      var newCartItemConfigurable = new ConfigurableItem();
      newCartItemConfigurable.cartItem = newCartItem;
      newCartItemConfigurable.cartItemAddons = newCartAddons;
      console.log(
        "ADDONS AL CARRELLO",
        newCartItemConfigurable.cartItemAddons.map(a => ({
          id: a.id,
          qty: a.selectedQuantity
        }))
      );

      CartHandler.addAddonToCartItem(newCartItemConfigurable)
        .then(() => {
          this.setState({
            addingToCart: false,
            showAddedToCart: true,
            loading: false,
          });
        })
        .catch((err) => {
          console.log(err.response.data);
          if (Array.isArray(err.response.data)) {
            this.setState({
              errorDialog: true,
              productsError: err.response.data,
              addingToCart: false,
              loading: false,
            });
          } else {
            this.setState({
              addingToCart: false,
              loading: false,
            });
          }
        });
    }
  };

  getQuantitySelector = (addonHelper: AddonHelper) => {
    // Trova lo selectedAddon nello state
    const selectedAddonState = this.state.selectedAddons.find(
      (s) => s.id === addonHelper.id
    );
    if (!selectedAddonState) return [];

    const selectedOptionId = selectedAddonState.selectedAddon?.selectedOptionId;
    if (!selectedOptionId) return [];

    // Trova l'opzione selezionata
    const selectedOption = addonHelper.addon.options.find(
      (o) => o.id === selectedOptionId
    );
    if (!selectedOption) return [];

    // Imposta quantità massima (business rule)
    let maxQuantity = selectedOption.obligatory > 0 ? 50 : 8;

    // Array da 1 a maxQuantity
    return Array.from({ length: maxQuantity }, (_, i) => i + 1);
  };


  onChangeSelectedQuantity = (e: any, addonHelper: AddonHelper) => {
    let stopLoop = false;
    let selectedAddonsCopy = this.state.selectedAddons.slice();
    selectedAddonsCopy.every((selectedAddon, index) => {
      if (selectedAddon.id === addonHelper.id) {
        addonHelper.addon.options.every((option: Option) => {
          if (option.id === selectedAddon.selectedAddon.selectedOptionId) {
            if (e.target.value !== 0) {
              selectedAddon.selectedAddon.selectedQuantity = e.target.value;
            } else {
              selectedAddon.selectedAddon = new CartItemAddon();
            }
            stopLoop = true;
            return false;
          }
          return true;
        });
        return !stopLoop;
      }
      return !stopLoop;
    });
    this.setState({
      selectedAddons: selectedAddonsCopy,
      configurationDocument: ConfigurationDocument({
        product: this.state.selectedProduct,
        productAddons: this.state.productAddons,
        selectedAddons: selectedAddonsCopy,
        quantity: this.state.selectedQuantity,
      }),
    });
  };

  getSelectedQuantity = (addonHelper: AddonHelper) => {
    let newSelectedOption = new CartItemAddon();
    let stopLoop = false;

    this.state.selectedAddons.every((selectedAddon) => {
      if (selectedAddon.id === addonHelper.id) {
        addonHelper.addon.options.every((option: Option) => {
          if (option.id === selectedAddon.selectedAddon.selectedOptionId) {
            newSelectedOption = selectedAddon.selectedAddon;
            stopLoop = true;
            return false;
          }
          return true;
        });
      }
      return !stopLoop;
    });
    if (stopLoop) {
      return newSelectedOption.selectedQuantity;
    } else {
      return 0;
    }
  };

  setShowAddToCartDialog = (show: boolean) => {
    this.setState({
      showAddToCartDialog: show,
    });
  };

  clearOptions = () => {
    let standardOptions = new Array<AddonCartHelper>();
    this.state.productAddons.forEach((addon) => {
      if (addon.addon.options.length < 1) {
        let selectedAddon = new AddonCartHelper();
        selectedAddon.id = addon.id;
        selectedAddon.selectedAddon.id = addon.id;
        selectedAddon.selectedAddon.addonSku = addon.addon.sku;
        selectedAddon.selectedAddon.selectedOptionId = null;
        selectedAddon.selectedAddon.addonName = addon.addon.name;
        selectedAddon.selectedAddon.selectedOptionName = "DEFAULT";
        if (selectedAddon.selectedAddon.selectedOption === undefined) {
          selectedAddon.selectedAddon.selectedOption = new CartItemOption();
        }
        selectedAddon.selectedAddon.selectedOption.price = 0;
        selectedAddon.selectedAddon.selectedQuantity = 1;
        standardOptions.push(selectedAddon);
      } else {
        addon.addon.options.every((option) => {
          if (option !== null && (option.stock1 > 0 || option.obligatory > 0)) {
            let selectedAddon = new AddonCartHelper();
            selectedAddon.id = addon.id;
            selectedAddon.selectedAddon.selectedOptionId = option.id;
            selectedAddon.selectedAddon.addonName = option.name;
            selectedAddon.selectedAddon.addonSku = addon.addon.sku;
            if (selectedAddon.selectedAddon.selectedOption !== undefined) {
              selectedAddon.selectedAddon.selectedOption.price = option.price;
            } else {
              selectedAddon.selectedAddon.selectedOption = new CartItemOption();
              selectedAddon.selectedAddon.selectedOption.price = option.price;
            }
            selectedAddon.selectedAddon.selectedQuantity = 1;
            standardOptions.push(selectedAddon);
            return false;
          }
          return true;
        });
      }
    });
    this.setState({
      selectedAddons: standardOptions,
      configurationDocument: ConfigurationDocument({
        product: this.state.selectedProduct,
        productAddons: this.state.productAddons,
        selectedAddons: standardOptions,
        quantity: this.state.selectedQuantity,
      }),
    });
  };

  getAddToCartBtnStatus = (): ECartBtnStatus => {
    if (this.state.loading) {
      console.log("loading");
      return ECartBtnStatus.disabled;
    } else if (!this.state.loggedIn) {
      console.log("notLogged");
      return ECartBtnStatus.notLoggedIn;
    } /*else if (
      this.state.selectedProduct.stock1 < 1 &&
      !this.state.selectedProduct.configurable
    ) {
      return ECartBtnStatus.outOfStock;
    }*/ else {
      return ECartBtnStatus.normal;
    }
  };

  getAddToCartBtnColor = (): string => {
    if (this.state.selectedProduct.stock1 === 0 && this.state.selectedProduct.arrivingQuantity === 0) {
      return "orange";
    } else if (this.state.selectedProduct.arrivingQuantity > 0 && (this.state.selectedQuantity > this.state.selectedProduct.stock1) && (this.state.selectedQuantity <= this.state.selectedProduct.arrivingQuantity + this.state.selectedProduct.stock1)) {
      return "orange";
    } else if (this.state.selectedProduct.arrivingQuantity > 0 && (this.state.selectedQuantity > this.state.selectedProduct.arrivingQuantity + this.state.selectedProduct.stock1)) {
      return "orange";
    } else if (this.state.selectedProduct.stock1 > 0 && this.state.selectedQuantity > this.state.selectedProduct.stock1) {
      return "orange";
    } else {
      return "#b3071b";
    }
  };

  onImageClick = (imageLink: any) => {
    this.setState({
      selectedImage: imageLink,
    });
  };

  addSameOption = (newAddon: AddonHelper, index: number) => {
    var newAddons = this.state.productAddons.slice();
    var selectedAddons = this.state.selectedAddons.slice();
    var addon = new AddonHelper();
    var selectedAddon = new AddonCartHelper();
    addon.addon = newAddon.addon;
    addon.id = "_" + Math.random().toString(36).substr(2, 9);
    addon.deletable = true;
    selectedAddon.id = addon.id;
    this.state.selectedAddons.every((selected) => {
      if (selected.id === newAddon.id) {
        selectedAddon.selectedAddon.id = selected.selectedAddon.id;
        selectedAddon.selectedAddon.selectedOptionId =
          selected.selectedAddon.selectedOptionId;
        selectedAddon.selectedAddon.selectedOption = new CartItemOption();
        selectedAddon.selectedAddon.selectedOption =
          selected.selectedAddon.selectedOption;
        selectedAddon.selectedAddon.addonName =
          selected.selectedAddon.addonName;
        selectedAddon.selectedAddon.addonSku = selected.selectedAddon.addonSku;
        selectedAddon.selectedAddon.selectedQuantity =
          selected.selectedAddon.selectedQuantity;
        return false;
      }
      return true;
    });
    selectedAddons.push(selectedAddon);
    newAddons.splice(index + 1, 0, addon);
    this.setState({
      productAddons: newAddons,
      selectedAddons: selectedAddons,
      configurationDocument: ConfigurationDocument({
        product: this.state.selectedProduct,
        productAddons: newAddons,
        selectedAddons: selectedAddons,
        quantity: this.state.selectedQuantity,
      }),
    });
  };

  removeSameOption = (newAddon: AddonHelper, index: number) => {
    var newAddons = this.state.productAddons.slice();
    var selectedAddons = this.state.selectedAddons.slice();
    newAddons.splice(index, 1);
    this.state.selectedAddons.every((selected, index2) => {
      if (selected.id === newAddon.id) {
        selectedAddons.splice(index2, 1);
        return false;
      }
      return true;
    });
    this.setState({
      productAddons: newAddons,
      selectedAddons: selectedAddons,
      configurationDocument: ConfigurationDocument({
        product: this.state.selectedProduct,
        productAddons: newAddons,
        selectedAddons: selectedAddons,
        quantity: this.state.selectedQuantity,
      }),
    });
  };

  onAddToLaterListControl = () => {
    LaterListHandler.GetLaterList()
      .then((laterList) => {
        let invalid = false;
        laterList.products.every((item) => {
          if (item.product.id === this.props.productIdToDisplay) {
            invalid = true;
            return false;
          }
          return true;
        });
        if (!invalid) {
          this.onAddToLaterList();
        } else {
          this.setState({
            openLaterListError: true,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onAddToLaterList = () => {
    const payload: AddProductToLaterListRequest = {
      productId: this.props.productIdToDisplay,
      quantity: this.state.selectedQuantity,
      configurable: this.state.selectedProduct.configurable,
      selectedAddons: this.state.selectedAddons
        .filter((x) => x.selectedAddon && x.selectedAddon.id !== "")
        .map((x) => ({
          id: x.id,
          selectedAddon: {
            id: x.selectedAddon.id,
            addonName: x.selectedAddon.addonName,
            addonSku: x.selectedAddon.addonSku,
            selectedOptionId: x.selectedAddon.selectedOptionId,
            selectedOptionName: x.selectedAddon.selectedOptionName,
            selectedOptionPrice: x.selectedAddon.selectedOptionPrice,
            selectedQuantity: x.selectedAddon.selectedQuantity,
            selectedOption: x.selectedAddon.selectedOption,
          },
        })),
    };

    LaterListHandler.AddProductToLaterList(payload)
      .then(() => {
        this.setState({
          showAddedToLaterList: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getSavedIdFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("savedId");
  };

  render() {
    return (
      <div style={{ paddingBottom: "5%" }} className="product-configurator">
        <Snackbar
          autoHideDuration={10000}
          open={this.state.showAddedToCart}
          onClose={() => this.setState({ showAddedToCart: false })}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          style={{ marginTop: "5%" }}
        >
          <Alert
            variant={"filled"}
            onClose={() => this.setState({ showAddedToCart: false })}
            severity="success"
            action={
              <div>
                <Link to={"/carrello"}>
                  <Button color="inherit" size="small">
                    Visualizza Carrello
                  </Button>
                </Link>
                <IconButton
                  onClick={() => this.setState({ showAddedToCart: false })}
                  color="inherit"
                  size="small"
                >
                  <Close />
                </IconButton>
              </div>
            }
          >
            Prodotto aggiunto al carrello!
          </Alert>
        </Snackbar>
        <Snackbar
          style={{ marginTop: "5%" }}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={this.state.errorDialog}
          autoHideDuration={6000}
          onClose={() => {
            this.setState({ errorDialog: false });
          }}
        >
          <Alert
            variant={"filled"}
            onClose={() => {
              this.setState({ errorDialog: false });
            }}
            severity="error"
          >
            <h3 style={{ margin: 0, textAlign: "left" }}>
              Aggiunta non possibile
            </h3>
            <h4 style={{ margin: 0, textAlign: "left", fontWeight: "normal" }}>
              Quantità massima raggiunta per i seguenti prodotti:
            </h4>
            {this.state.productsError.map((item) => {
              return (
                <div style={{ textAlign: "left" }} key={item.id}>
                  <span style={{ fontSize: "14px", padding: 0 }}>
                    {item.productName}
                  </span>
                </div>
              );
            })}
          </Alert>
        </Snackbar>
        <Snackbar
          autoHideDuration={10000}
          open={this.state.showAddedToLaterList}
          onClose={() => this.setState({ showAddedToLaterList: false })}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          style={{ marginTop: "5%" }}
        >
          <Alert
            variant={"filled"}
            onClose={() => this.setState({ showAddedToLaterList: false })}
            severity="success"
            action={
              <div>
                <Link to={"/shop/saved/page/1"}>
                  <Button color="inherit" size="small">
                    Visualizza i prodotti salvati
                  </Button>
                </Link>
                <IconButton
                  onClick={() => this.setState({ showAddedToLaterList: false })}
                  color="inherit"
                  size="small"
                >
                  <Close />
                </IconButton>
              </div>
            }
          >
            Prodotto aggiunto alla lista!
          </Alert>
        </Snackbar>
        <Snackbar
          autoHideDuration={10000}
          open={this.state.openLaterListError}
          onClose={() => this.setState({ openLaterListError: false })}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          style={{ marginTop: "5%" }}
        >
          <Alert
            variant={"filled"}
            onClose={() => this.setState({ openLaterListError: false })}
            severity="warning"
            action={
              <div>
                <IconButton
                  onClick={() => this.setState({ openLaterListError: false })}
                  color="inherit"
                  size="small"
                >
                  <Close />
                </IconButton>
              </div>
            }
          >
            Il prodotto è già presente nella lista!
          </Alert>
        </Snackbar>
        <div style={{ marginTop: "1%", marginLeft: "2%" }}>
          <this.CustomBreadCrumbs />
        </div>
        {/*<Button
          variant={"contained"}
          startIcon={<ArrowBack />}
          color={"primary"}
          style={{ float: "left", marginTop: "1%", marginLeft: "2%" }}
        >
          <Link to={{ pathname: this.navigateBack() }}> Torna Indietro</Link>
        </Button>*/}
        <Grid container style={{ paddingLeft: "2%", width: "100%" }}>
          <Grid style={{ marginBottom: "1%" }} md={12} item></Grid>
          <Grid
            alignContent={"center"}
            alignItems={"center"}
            justifyContent={"center"}
            direction={"row"}
            md={12}
            container
            item
          >
            <Snackbar
              autoHideDuration={10000}
              open={this.state.showAddToCartAlert}
              onClose={() => this.setState({ showAddToCartAlert: false })}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              style={{ marginTop: "5%" }}
            >
              <Alert
                variant={"filled"}
                onClose={() => this.setState({ showAddToCartAlert: false })}
                severity="warning"
                action={
                  <div>
                    <IconButton
                      onClick={() =>
                        this.setState({ showAddToCartAlert: false })
                      }
                      color="inherit"
                      size="small"
                    >
                      <Close />
                    </IconButton>
                  </div>
                }
              >
                Attenzione! La quantità delle opzioni di configurazione
                richiesta è superiore a quella presente in magazzino.
              </Alert>
            </Snackbar>
          </Grid>
        </Grid>
        <Grid style={{ paddingLeft: "2%" }} container>
          <Grid md={8} item>
            <Grid container>
              <Grid
                style={{
                  marginTop: "5%",
                  overflow: "hidden",
                  maxWidth: "100%",
                  height: "300px",
                }}
                direction={"column"}
                xs={3}
                justifyContent={"center"}
                alignContent={"center"}
                item
                container
              >
                {this.state.loadingProduct ? (
                  <Skeleton width={"100%"} height={"100%"} animation="wave" />
                ) : (
                  <div style={{ overflow: "hidden" }}>
                    {
                      <img
                        style={{
                          height: "100%",
                          width: "100%",
                          objectFit: "contain",
                        }}
                        src={this.state.selectedImage}
                        alt={this.state.selectedProduct.name + "-image"}
                      />
                    }
                  </div>
                )}
              </Grid>
              <Grid style={{ paddingTop: "2%", paddingLeft: "3%" }} md={8} item>
                {this.state.loadingProduct ? (
                  <Skeleton height={50} animation="wave" />
                ) : (
                  <Typography
                    style={{
                      marginTop: "1%",
                      textAlign: "left",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontWeight: 700,
                    }}
                    gutterBottom
                    variant="h4"
                    component="h2"
                  >
                    {this.state.selectedProduct.name}
                  </Typography>
                )}
                <Grid
                  style={{ marginBottom: "2%" }}
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  container
                >
                  <Button
                    onClick={this.onAddToLaterListControl}
                    variant="outlined"
                    startIcon={<AssignmentTurnedIn />}
                    disabled={!this.state.loggedIn}
                  >
                    Salva per dopo
                  </Button>
                </Grid>
                {!this.state.loadingProduct &&
                  this.state.selectedProduct.images !== undefined &&
                  this.state.selectedProduct.images.length > 1 ? (
                  <Grid
                    style={{
                      overflow: "hidden",
                      maxWidth: "100%",
                      height: "5vw",
                      marginBottom: "1%",
                    }}
                    direction={"row"}
                    justifyContent={"center"}
                    alignContent={"flex-start"}
                    item
                    container
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        height: "5vw",
                        justifyContent: "flex-start",
                        marginTop: "1%",
                      }}
                    >
                      {this.state.selectedProduct.images.map((image, index) => {
                        if (index < 7) {
                          return (
                            <div
                              onClick={() => this.onImageClick(image.link)}
                              style={{
                                marginRight: "1%",
                                width: "120px",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "cover",
                                backgroundImage: "url(" + image.link + ")",
                                cursor: "pointer",
                              }}
                            />
                          );
                        } else {
                          return null;
                        }
                      })}
                    </div>
                  </Grid>
                ) : (
                  ""
                )}
                {this.state.loadingProduct ? (
                  <Skeleton
                    width={"40%"}
                    style={{ marginBottom: "2%" }}
                    height={20}
                    animation="wave"
                  />
                ) : (
                  <Typography
                    style={{
                      textAlign: "left",
                      fontWeight: 400,
                      color: "light-grey",
                      paddingBottom: "1%",
                    }}
                    gutterBottom
                    variant="subtitle2"
                  >
                    <b>Codice prodotto</b>: {this.state.selectedProduct.sku}{" "}
                    {"  "}
                    {this.state.selectedProduct.internalCode !== undefined &&
                      this.state.selectedProduct.internalCode !== null &&
                      this.state.selectedProduct.internalCode !== "" ? (
                      <div>
                        <b>Part Number</b>:{" "}
                        {this.state.selectedProduct.internalCode}
                      </div>
                    ) : (
                      ""
                    )}
                    {this.state.selectedProduct.model !== undefined &&
                      this.state.selectedProduct.model !== null &&
                      this.state.selectedProduct.model !== "" ? (
                      <div>
                        <b>Modello</b>: {this.state.selectedProduct.model}
                      </div>
                    ) : (
                      ""
                    )}
                    {this.state.selectedProduct.maker !== undefined &&
                      this.state.selectedProduct.maker !== null &&
                      this.state.selectedProduct.maker !== "" ? (
                      <div>
                        <b>Marca</b>: {this.state.selectedProduct.maker}
                      </div>
                    ) : (
                      ""
                    )}
                  </Typography>
                )}

                {
                  <Grid container>
                    <Grid
                      alignContent={"flex-start"}
                      direction={"column"}
                      xs={12}
                      container
                      item
                    >
                      <this.CustomAccordion />
                    </Grid>
                  </Grid>
                }
              </Grid>
            </Grid>
            <br />
          </Grid>
          <Grid
            style={{ marginTop: "30px", paddingLeft: "3%", paddingRight: "2%" }}
            md={4}
            item
          >
            <div
              style={{
                boxShadow: "10px 12px 24px 1px lightGrey",
                textAlign: "left",
                padding: "15px",
                borderRadius: "10px",
                marginBottom: "63px",
              }}
            >
              {!this.state.loggedIn ? (
                ""
              ) : (
                <div>
                  <Typography
                    style={{
                      paddingBottom: "2%",
                      color: "light-grey",
                      textAlign: "left",
                    }}
                    variant="subtitle2"
                  >
                    Riepilogo prodotto
                  </Typography>
                  {this.state.loading ? (
                    <Skeleton width={"50%"} height={50} animation="wave" />
                  ) : (
                    <Typography
                      style={{
                        fontWeight: 700,
                        paddingBottom: "2%",
                        whiteSpace: "nowrap",
                      }}
                      variant="h3"
                    >
                      {euroPrint(this.calculatePrice())}
                    </Typography>
                  )}
                  {this.state.selectedProduct.status.toLowerCase() ===
                    "in esaurimento" ? (
                    <Chip
                      size="small"
                      icon={<MoneyOff style={{ color: "white" }} />}
                      style={{
                        marginRight: "5px",
                        marginTop: "5px",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        marginBottom: "10px",
                        backgroundColor: "green",
                        color: "white",
                      }}
                      label={"In Promozione"}
                    />
                  ) : (
                    ""
                  )}
                  <Divider />
                </div>
              )}
              <Typography
                style={{
                  paddingTop: !this.state.loggedIn ? "2%" : "5%",
                  paddingBottom: "3%",
                  color: "light-grey",
                  textAlign: "left",
                }}
                variant="subtitle2"
              >
                Informazioni
              </Typography>
              {this.state.selectedProduct.taxSIAE !== null &&
                this.state.selectedProduct.taxSIAE !== 0 &&
                this.state.selectedProduct.taxSIAE !== undefined ? (
                <Typography
                  style={{
                    paddingBottom: "2%",
                    color: "black",
                    textAlign: "left",
                  }}
                  variant="subtitle2"
                >
                  <FontAwesomeIcon
                    style={{ color: "black", marginRight: "5px" }}
                    icon={faClipboardList}
                  />{" "}
                  Prezzo comprensivo di SIAE:{" "}
                  {euroPrint(this.state.selectedProduct.taxSIAE)}
                </Typography>
              ) : (
                ""
              )}
              <Typography
                style={{
                  paddingBottom: "2%",
                  color: "black",
                  textAlign: "left",
                }}
                variant="subtitle2"
              >
                <FontAwesomeIcon style={{ color: "black" }} icon={faTruck} />{" "}
                Spedizione Disponibile
              </Typography>

              {this.state.selectedProduct.configurable ||
                !this.state.loggedIn ? (
                ""
              ) : (
                <div>
                  <Typography
                    style={{
                      paddingTop: !this.state.loggedIn ? "2%" : "5%",
                      paddingBottom: "3%",
                      color: "light-grey",
                      textAlign: "left",
                    }}
                    variant="subtitle2"
                  >
                    Disponibilita' di magazzino
                  </Typography>
                  <Typography
                    style={{
                      paddingBottom: "2%",
                      color:
                        this.state.selectedProduct.stock1 < 1 ? "red" : "green",
                      textAlign: "left",
                    }}
                    variant="subtitle2"
                  >
                    <FontAwesomeIcon style={{ color: "black" }} icon={faBox} />{" "}
                    Magazzino: {this.state.selectedProduct.stock1} pezzi
                  </Typography>
                </div>
              )}

              {this.state.selectedProduct.arrivingQuantity > 0 &&
                this.state.loggedIn ? (
                <Typography
                  style={{
                    paddingBottom: "2%",
                    color:
                      this.state.selectedProduct.arrivingQuantity < 1
                        ? "red"
                        : "green",
                    textAlign: "left",
                  }}
                  variant="subtitle2"
                >
                  <FontAwesomeIcon style={{ color: "black" }} icon={faDolly} />{" "}
                  {"In arrivo " +
                    this.state.selectedProduct.arrivingQuantity +
                    (this.state.selectedProduct.arrivingQuantityDate !== ""
                      ? dayjs(
                        this.state.selectedProduct.arrivingQuantityDate,
                        "YYYY-MM-DD"
                      ).isSame(dayjs()) ||
                        dayjs(
                          this.state.selectedProduct.arrivingQuantityDate,
                          "YYYY-MM-DD"
                        ).isBefore(dayjs())
                        ? " durante la giornata odierna"
                        : " dal " +
                        dayjs(
                          this.state.selectedProduct.arrivingQuantityDate,
                          "YYYY-MM-DD"
                        ).format("DD/MM/YYYY")
                      : "")}
                </Typography>
              ) : (
                ""
              )}
              <br />
              <div style={{ display: "flex", flexDirection: "row" }}>
                {/* <Select
                  variant={"outlined"}
                  style={{ marginRight: "2%", width: "20%" }}
                  onChange={this.onQuantityChange}
                  value={this.state.selectedQuantity}
                  label={"Quantità"}
                  inputProps={{
                    name: "quantità",
                    id: "outlined-quantity-native-simple",
                  }}
                  input={<OutlinedInput name="cuisine" id="cuisines" />}
                >
                  {this.state.quantityArray.map((quantity) => {
                    return (
                      <MenuItem key={"prod" + quantity} value={quantity}>
                        {quantity}
                      </MenuItem>
                    );
                  })}
                </Select> */}
                <TextField
                  variant="outlined"
                  type="number"
                  label="Quantità"
                  value={this.state.selectedQuantity}
                  onChange={this.onQuantityChange}
                  inputProps={{ min: 1 }}
                  style={{ marginRight: "2%", width: "25%" }}
                />
                <AddToCartBtn
                  loading={this.state.addingToCart}
                  status={this.getAddToCartBtnStatus()}
                  onPress={this.addToCartControl}
                  color={this.getAddToCartBtnColor()}
                />
              </div>
              {this.state.selectedProduct.stock1 === 0 && this.state.selectedProduct.arrivingQuantity === 0 ?
                <Typography
                  style={{
                    paddingTop: "5%",
                    // paddingBottom: "5%",
                    // fontWeight: 400,
                    color: "orange",
                    textAlign: "left",
                  }}
                  variant="subtitle2"
                >
                  Da ordinare.
                  <Tooltip title="Contatta il commerciale per chiedere i tempi di consegna della merce contrassegnata da ‘ordinare">
                    <InfoIcon
                      fontSize="medium"
                      style={{
                        cursor: "pointer",
                        color: "#990617",
                        verticalAlign: "middle", // 🔥 allineamento
                        marginLeft: 4,
                      }}
                    />
                  </Tooltip>
                </Typography> :
                this.state.selectedProduct.arrivingQuantity > 0 && (this.state.selectedQuantity > this.state.selectedProduct.stock1) && (this.state.selectedQuantity <= this.state.selectedProduct.arrivingQuantity + this.state.selectedProduct.stock1) ?
                  <Typography
                    style={{
                      paddingTop: "5%",
                      // paddingBottom: "5%",
                      // fontWeight: 400,
                      color: "orange",
                      textAlign: "left",
                    }}
                    variant="subtitle2"
                  >
                    Per {this.state.selectedQuantity - this.state.selectedProduct.stock1} pezzi il tempo di arrivo sarà
                    {(this.state.selectedProduct.arrivingQuantityDate !== ""
                      ? dayjs(
                        this.state.selectedProduct.arrivingQuantityDate,
                        "YYYY-MM-DD"
                      ).isSame(dayjs()) ||
                        dayjs(
                          this.state.selectedProduct.arrivingQuantityDate,
                          "YYYY-MM-DD"
                        ).isBefore(dayjs())
                        ? " durante la giornata odierna"
                        : " al " +
                        dayjs(
                          this.state.selectedProduct.arrivingQuantityDate,
                          "YYYY-MM-DD"
                        ).format("DD/MM/YYYY")
                      : "")}.
                  </Typography> :
                  this.state.selectedProduct.arrivingQuantity > 0 && (this.state.selectedQuantity > this.state.selectedProduct.arrivingQuantity + this.state.selectedProduct.stock1) ?
                    <Typography
                      style={{
                        paddingTop: "5%",
                        // paddingBottom: "5%",
                        // fontWeight: 400,
                        color: "orange",
                        textAlign: "left",
                      }}
                      variant="subtitle2"
                    >
                      {this.state.selectedQuantity - this.state.selectedProduct.arrivingQuantity - this.state.selectedProduct.stock1} pezzi sono da ordinare
                      <Tooltip title="Contatta il commerciale per chiedere i tempi di consegna della merce contrassegnata da ‘ordinare">
                        <InfoIcon
                          fontSize="medium"
                          style={{
                            cursor: "pointer",
                            color: "#990617",
                            verticalAlign: "middle", // 🔥 allineamento
                            marginLeft: 4,
                          }}
                        />
                      </Tooltip>
                      {/* {(this.state.selectedProduct.arrivingQuantityDate !== ""
                        ? dayjs(
                          this.state.selectedProduct.arrivingQuantityDate,
                          "YYYY-MM-DD"
                        ).isSame(dayjs()) ||
                          dayjs(
                            this.state.selectedProduct.arrivingQuantityDate,
                            "YYYY-MM-DD"
                          ).isBefore(dayjs())
                          ? " dopo la giornata odierna"
                          : " dopo il " +
                          dayjs(
                            this.state.selectedProduct.arrivingQuantityDate,
                            "YYYY-MM-DD"
                          ).format("DD/MM/YYYY")
                        : "")}. */}
                    </Typography> :
                    this.state.selectedProduct.stock1 > 0 && this.state.selectedQuantity > this.state.selectedProduct.stock1 &&
                    <Typography
                      style={{
                        paddingTop: "5%",
                        // paddingBottom: "5%",
                        // fontWeight: 400,
                        color: "orange",
                        textAlign: "left",
                      }}
                      variant="subtitle2"
                    >
                      Da ordinare.
                      <Tooltip title="Contatta il commerciale per chiedere i tempi di consegna della merce contrassegnata da ‘ordinare">
                        <InfoIcon
                          fontSize="medium"
                          style={{
                            cursor: "pointer",
                            color: "#990617",
                            verticalAlign: "middle", // 🔥 allineamento
                            marginLeft: 4,
                          }}
                        />
                      </Tooltip>
                    </Typography>}
              <Typography
                style={{
                  paddingTop: "5%",
                  paddingBottom: "5%",
                  fontWeight: 400,
                  color: "light-grey",
                  textAlign: "left",
                }}
                variant="subtitle2"
              >
                <b>ATTENZIONE:</b> I prezzi e le disponibilità sono soggetti a variazioni senza alcun preavviso. Dettagli e caratteristiche del prodotto sono da ritenersi puramente informative e non contengono alcun tipo di garanzia né implicita né esplicita. Le immagini sono fornite al solo scopo illustrativo e non costituiscono elemento contrattuale.
              </Typography>
            </div>
          </Grid>
        </Grid>
        <div hidden={!this.state.loadingConfiguration}>
          <CircularProgress />
        </div>
        <div
          className="configurator"
          hidden={this.state.productAddons.length <= 0 || !this.state.loggedIn}
        >
          <Divider variant="middle" />
          <Typography
            style={{ marginTop: "2.5%", marginBottom: "2%" }}
            variant="h4"
            component="h2"
          >
            Opzioni di configurazione
          </Typography>
          <div
            style={{
              marginBottom: "1%",
              display: "flex",
              justifyContent: "center",
              marginLeft: "auto",
              marginRight: 0,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<Restore />}
              onClick={this.clearOptions}
              style={{ marginRight: "2%" }}
            >
              Resetta configurazione
            </Button>
            <PDFDownloadLink
              document={this.state.configurationDocument}
              fileName={`offerta-${this.state.selectedProduct.sku}-${dayjs().format('YYYY-MM-DD')}.pdf`}
            >
              {(p) => (
                // @ts-ignore
                <Button
                  disabled={p.loading}
                  variant="contained"
                  onClick={this.onConfigDownload}
                  color="primary"
                  startIcon={<DocumentScanner />}
                >
                  Scarica Configurazione
                </Button>
              )}
            </PDFDownloadLink>
          </div>
          <TableContainer style={{ width: "100%" }} component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Nome</TableCell>
                  <TableCell>Opzione</TableCell>
                  <TableCell>Quantità</TableCell>
                  {!this.state.loggedIn ? null : <TableCell>Prezzo</TableCell>}
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.productAddons.map(
                  (addon: AddonHelper, confIndex: number) => {
                    return (
                      <TableRow key={"config" + confIndex}>
                        <TableCell>{addon.addon.name}</TableCell>
                        <TableCell>
                          {addon.addon.options.length < 1 ? (
                            "DEFAULT"
                          ) : (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                              <Select
                                variant={"standard"}
                                value={this.getSelectedOption(addon)}
                                onChange={(e) =>
                                  this.handleRowSelectionChange(e, addon)
                                }
                                disabled={addon.addon.options.length < 1}
                              >
                                {addon.addon.obligatory > 0 ? (
                                  // Check if there is any selectable stock
                                  this.getNoneIfNoStock(addon)
                                ) : (
                                  <MenuItem value={""}>Nessuno</MenuItem>
                                )}
                                {addon.addon.options.map(
                                  (option: Option, selIndex: number) => {
                                    return (
                                      <MenuItem
                                        key={"op" + selIndex}
                                        value={option.sku}
                                      >
                                        <span style={{ marginRight: "1%" }}>
                                          {option.name} ({option.sku})
                                        </span>

                                        {option.stock1 > 0 ? (
                                          <span style={{ color: "green" }}>
                                            ({option.stock1} pezzi)
                                          </span>
                                        ) : option.obligatory > 0 ? (
                                          ""
                                        ) : option.stock1 === 0 && this.state.productsByAddon.find(x => x.sku === option.sku)?.arrivingQuantity === 0 ? (
                                          <span style={{ color: "red" }}>
                                            Da ordinare
                                          </span>
                                        ) : this.state.productsByAddon.find(x => x.sku === option.sku)!.arrivingQuantity > 0 && (
                                          <span style={{ color: "orange" }}>
                                            {(this.state.productsByAddon.find(x => x.sku === option.sku)!.arrivingQuantityDate !== ""
                                              ? dayjs(
                                                this.state.productsByAddon.find(x => x.sku === option.sku)!.arrivingQuantityDate,
                                                "YYYY-MM-DD"
                                              ).isSame(dayjs()) ||
                                                dayjs(
                                                  this.state.productsByAddon.find(x => x.sku === option.sku)!.arrivingQuantityDate,
                                                  "YYYY-MM-DD"
                                                ).isBefore(dayjs())
                                                ? "Arrivo previsto oggi" + " (" + this.state.productsByAddon.find(x => x.sku === option.sku)!.arrivingQuantity + " pezzi)"
                                                : "Disponibile al " +
                                                dayjs(
                                                  this.state.productsByAddon.find(x => x.sku === option.sku)!.arrivingQuantityDate,
                                                  "YYYY-MM-DD"
                                                ).format("DD/MM/YYYY")
                                              : "")}
                                          </span>
                                        )}
                                      </MenuItem>
                                    );
                                  }
                                )}
                              </Select>
                              {(() => {
                                const selectedQty = this.getSelectedQuantity(addon) || 1;
                                const selectedAddonState = this.state.selectedAddons.find(
                                  (s) => s.id === addon.id
                                );
                                const selectedOption = addon.addon.options.find(
                                  (o) =>
                                    o.id === selectedAddonState?.selectedAddon.selectedOptionId
                                );
                                const stock = selectedOption?.stock1 ?? 0;

                                return selectedQty > stock && this.state.productsByAddon.find(x => x.sku === selectedOption?.sku)?.arrivingQuantity === 0 ? (
                                  <Tooltip title="Contatta il commerciale per chiedere i tempi di consegna della merce contrassegnata da ‘ordinare">
                                    <InfoIcon fontSize="medium" style={{ cursor: 'pointer', color: '#990617' }} />
                                  </Tooltip>
                                ) : null;
                              })()}
                            </div>
                          )}
                        </TableCell>
                        <TableCell>
                          {addon.addon.options.length < 1 || addon.addon.obligatory > 0 ? (
                            "1"
                          ) : this.getSelectedOption(addon) === "" ? (
                            "Seleziona opzione"
                          ) : (
                            <>
                              <Select
                                variant="standard"
                                value={this.getSelectedQuantity(addon) || 1}
                                onChange={(e) => this.onChangeSelectedQuantity(e, addon)}
                              >
                                {this.getQuantitySelector(addon).map((quantity) => (
                                  <MenuItem key={addon.id + quantity} value={quantity}>
                                    {quantity}
                                  </MenuItem>
                                ))}
                              </Select>

                              {/* Messaggio per pezzi extra rispetto allo stock */}
                              {/* {(() => {
                                const selectedQty = this.getSelectedQuantity(addon) || 1;
                                const selectedAddonState = this.state.selectedAddons.find(
                                  (s) => s.id === addon.id
                                );
                                const selectedOption = addon.addon.options.find(
                                  (o) =>
                                    o.id === selectedAddonState?.selectedAddon.selectedOptionId
                                );
                                const stock = selectedOption?.stock1 ?? 0;

                                return selectedQty > stock ? (
                                  <span style={{ fontSize: "12px", color: "orange" }}>
                                    Per {selectedQty - stock} pezzi il tempo di arrivo sarà di 48/72h
                                  </span>
                                ) : null;
                              })()} */}
                            </>
                          )}
                        </TableCell>



                        {!this.state.loggedIn ? null : (
                          <TableCell style={{ whiteSpace: "nowrap" }}>
                            {euroPrint(
                              addon.addon.options.length > 0
                                ? this.getSelectedOptionPrice(addon)
                                : addon.addon.addonPrice
                            )}
                          </TableCell>
                        )}
                        <TableCell>
                          {addon.addon.duplicable ? (
                            <IconButton
                              onClick={() =>
                                this.addSameOption(addon, confIndex)
                              }
                              color="primary"
                              component={"span"}
                            >
                              <AddIcon />
                            </IconButton>
                          ) : (
                            ""
                          )}
                          {addon.deletable ? (
                            <IconButton
                              onClick={() =>
                                this.removeSameOption(addon, confIndex)
                              }
                              color="primary"
                              component={"span"}
                            >
                              <Delete />
                            </IconButton>
                          ) : (
                            ""
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  }
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div
          hidden={this.state.correlatedProduct.length < 1}
          style={{
            textAlign: "left",
            padding: "1% 2% 1% 2%",
            minHeight: "310px",
            backgroundColor: "#e9e9e9",
          }}
        >
          <Typography variant="h4">
            Solitamente acquistati insieme a questo prodotto
          </Typography>
          {this.state.loadingCorrelated ? (
            <div style={{ textAlign: "center" }}>
              <CircularProgress
                key={"correlated"}
                size={30}
                style={{
                  color: "#b3071b",
                  marginTop: "2%",
                  textAlign: "center",
                }}
              />
            </div>
          ) : (
            <Carousel
              responsive={responsive}
              additionalTransfrom={0}
              arrows={true}
              autoPlay={false}
              autoPlaySpeed={2000}
              centerMode={false}
              className={""}
              removeArrowOnDeviceType={["tablet", "mobile"]}
              dotListClass=""
              containerClass={"carouselStyle"}
              itemAriaLabel={"aria-label"}
              draggable
              focusOnSelect={false}
              itemClass={""}
              infinite
              keyBoardControl
              minimumTouchDrag={80}
              renderButtonGroupOutside={true}
              renderDotsOutside={false}
              showDots={true}
              sliderClass=""
              slidesToSlide={1}
              swipeable
            >
              {this.state.correlatedProduct.map(
                (product: Product, index: number) => {
                  return (
                    <CarouselCard key={product.id + index} product={product} />
                  );
                }
              )}
            </Carousel>
          )}
        </div>
      </div >
    );
  }

  // HELPER FUNCTION LINE 1725
  getNoneIfNoStock = (addon: AddonHelper): any => {
    let hasStock = false;
    console.log(addon.addon.options);
    addon.addon.options.every((option) => {
      if (option.stock1 > 0) {
        hasStock = true;
        return false;
      }
      return true;
    });

    if (hasStock) {
      return <></>
    } else {
      return <MenuItem value={""}>Nessuno</MenuItem>;
    }
  }

}

export default ProductView;
